var render, staticRenderFns
import script from "./tinymce-editor.vue?vue&type=script&lang=js"
export * from "./tinymce-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ac8727c')) {
      api.createRecord('1ac8727c', component.options)
    } else {
      api.reload('1ac8727c', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/js/components/tinymce-editor.vue"
export default component.exports